import { language } from "language/default";
import React from "react";
import { getLabel } from "../indicator-helper";
import { areFiniteNumbers } from "common/number-helper";
import { useWidgetCurrentGranularity } from "components/widgets/hooks/use-current-widget";
import { AuxTooltip } from "@blk/aladdin-react-components-es";
const { kpi } = language.en.widgets;
export const InsIndicatorTooltip = ({ newValue, oldValue, sectionId, widgetId, children }) => {
    const dataGranularity = useWidgetCurrentGranularity(sectionId, widgetId);
    if (!areFiniteNumbers(oldValue, newValue)) {
        return React.createElement(React.Fragment, null);
    }
    return React.createElement(React.Fragment, null,
        React.createElement(AuxTooltip, null,
            React.createElement("div", { slot: "target" }, children),
            React.createElement("div", { slot: "content" }, getLabel(kpi, dataGranularity))));
};
